import {DomainObject} from 'shared/store';
import {observable, action, computed} from 'mobx';
import {Employee} from 'main/stores/employees';
import Expense from './Expense';
import _ from 'lodash';

class ExpenseRequest extends DomainObject {
  @observable id;
  @observable title;
  @observable description;
  @observable status;
  @observable actionedNotes;
  @observable employee;
  @observable expenses = [];

  @action merge(other) {
    super.merge(other, {
      employee: Employee,
      expenses: [Expense],
      _dates: ['actionedAt']
    });
  }

  @computed get totalAmount() {
    return _.sumBy(this.expenses, 'amount') || 0;
  }
}

export default ExpenseRequest;
